import { render } from "./NerpathamReport.vue?vue&type=template&id=25d23549&scoped=true"
import script from "./NerpathamReport.vue?vue&type=script&lang=js"
export * from "./NerpathamReport.vue?vue&type=script&lang=js"

import "./NerpathamReport.vue?vue&type=style&index=0&id=25d23549&scoped=true&lang=css"

import exportComponent from "C:\\Users\\shuha\\Documents\\Wisdom guide front\\wg-frontend-v1\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-25d23549"]])

export default __exports__